import { QUERY_PARAMS } from './constants';
import { EnvironmentEnum, getAppName, getAppVersion, getEnvironment, isE2eTest } from './platform';
import useQuery from './useQuery';

export enum TracesSampleRateEnum {
  KIOSK = 0.66666667,
  E2ETEST = 0.25,
  DEFAULT = 0.1
}

export enum ReplaysOnErrorSampleRateEnum {
  KIOSK = 0.66666667,
  E2ETEST = 0.0,
  DEFAULT = 0.1
}

export enum ReplaysSessionSampleRateEnum {
  KIOSK = 0.1,
  DEFAULT = 0.0
}

export const E2E_TEST_ENVIRONMENT = 'TEST';

// Locales for countries the SKYTTA range isn't sold in but are still reached by Catchpoint.
export const unsupportedLocales = ['ja-JP', 'en-HK', 'zh-TW', 'en-JP', 'en-TW', 'zh-HK', 'en-PL'];

export const getReleaseName = () => {
  return `${getAppName()}@${getAppVersion()}`;
};

export const cleanVersion = (version: string) => {
  // This regex will remove any character that is not a digit (0-9) or a period '.'
  // Version numbers are usually specified for dependencies using certain characters like or other range specifiers.
  // Use this when you want to parse these version numbers and remove these characters to get the clean version number.
  return version.replace(/[^0-9.]/g, '');
};

export const getSentryEnvironment = () => {
  const environment = isE2eTest() ? E2E_TEST_ENVIRONMENT : getEnvironment();

  if (
    ![
      EnvironmentEnum.PRODUCTION,
      EnvironmentEnum.STAGE,
      EnvironmentEnum.LOCAL,
      E2E_TEST_ENVIRONMENT
    ].includes(environment)
  ) {
    console.warn('Unknown environment');
  }

  return environment;
};

export const isVerboseSentry = () => {
  return useQuery(QUERY_PARAMS.VERBOSE_SENTRY) === 'true';
};
